module.exports = __webpack_public_path__ + "img/Einsatzleiter.3b0ec2c0.svg";